import { useEffect, useState } from 'react'

function getBrowserVisibilityProp (): string | null {
  if (
    // @ts-expect-error compatibility check
    typeof document.mozHidden !== 'undefined'
  ) {
    return 'mozvisibilitychange'
  } else if (
    // @ts-expect-error compatibility check
    typeof document.msHidden !== 'undefined'
  ) {
    return 'msvisibilitychange'
  } else if (
    // @ts-expect-error compatibility check
    typeof document.webkitHidden !== 'undefined'
  ) {
    return 'webkitvisibilitychange'
  } else if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    return 'visibilitychange'
  } else {
    return null
  }
}

function getBrowserDocumentHiddenProp (): string | null {
  if (
    // @ts-expect-error compatibility check
    typeof document.mozHidden !== 'undefined'
  ) {
    return 'mozHidden'
  } else if (
    // @ts-expect-error compatibility check
    typeof document.msHidden !== 'undefined'
  ) {
    return 'msHidden'
  } else if (
    // @ts-expect-error compatibility check
    typeof document.webkitHidden !== 'undefined'
  ) {
    return 'webkitHidden'
  } else if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    return 'hidden'
  } else {
    return null
  }
}

function getIsDocumentHidden (): boolean {
  const hidden = getBrowserDocumentHiddenProp()
  if (hidden == null) {
    return false
  } else {
    // @ts-expect-error compatibility check
    return document[hidden]
  }
}

export function usePageVisibility (): boolean {
  const [isHidden, setIsHidden] = useState(getIsDocumentHidden())
  const onVisibilityChange = (): void => {
    setIsHidden(getIsDocumentHidden())
  }

  useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp()

    if (visibilityChange != null) {
      document.addEventListener(visibilityChange, onVisibilityChange, false)
    }

    return () => {
      if (visibilityChange != null) {
        document.removeEventListener(visibilityChange, onVisibilityChange)
      }
    }
  })

  return isHidden
}
